import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class PostRecommendForm extends FormBase {
    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getModal(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL}"]`, HTMLElement);
    }

    public getListRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL_LIST}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL_CLOSE}"]`, HTMLElement);
    }

    public getTitleRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL_TITLE}"]`, HTMLElement);
    }

    public getBoardIdSuffix(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_MODAL_BOARD_ID}"]`, HTMLElement);
    }

    public getUnsetButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-action="select-clear"]`);
    }

    public getModalButtons(root: ParentNode = document): HTMLButtonElement[] {
        return this.queryElements(root, "button", HTMLButtonElement);
    }

    public getRecommendButtons(
        root: ParentNode = document,
        boardId?: string | null,
        postId?: number | null,
    ): HTMLElement[] {
        const selectorParts = [`[data-role="${Roles.POST_RECOMMEND_BTN}"]`];

        if (typeof boardId === "string" && boardId.trim() !== "") {
            selectorParts.push(`[data-board-id="${boardId.trim()}"]`);
        }

        if (typeof postId === "number" && Number.isFinite(postId) && postId > 0) {
            selectorParts.push(`[data-post-id="${postId}"]`);
        }

        return this.queryElements(root, selectorParts.join(""), HTMLElement);
    }

    public getClosestRecommendButton(target: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(target, `[data-role="${Roles.POST_RECOMMEND_BTN}"]`, HTMLElement);
    }

    public getRecommendCapabilityHost(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, '[data-can-recommend="1"]', HTMLElement);
    }

    public getRecommendBadgeRank(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_BADGE_RANK}"]`, HTMLElement);
    }

    public getRecommendBadgeSpinner(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_RECOMMEND_BADGE_SPINNER}"]`, HTMLElement);
    }
}

export const postRecommendForm = new PostRecommendForm();
